'use client'

import { RawStoreData } from '@/lib/stores/store-types'
import { getTodaysHours, upcomingSpecialHoursMessage } from '@/lib/store-hours'
import { isStoreVeryClosed } from '@/lib/utils'

export default function StoreDetailHours({
	locale,
	store,
	dictionary,
	currentTime,
}: {
	locale: string
	store: RawStoreData
	dictionary: Record<string, string>
	currentTime: Date
}) {
	const { day, isOpen, end } = getTodaysHours(store, currentTime)
	const upcomingSpecialHours = upcomingSpecialHoursMessage(locale, currentTime, store)
	const isVeryClosed = isStoreVeryClosed(store)

	return (
		<div role="region" aria-label={dictionary['store-hours']}>
			<div className="space-y-2">
				{['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((weekday) => (
					<div key={weekday} className="flex justify-between text-sm">
						<span
							className={`${weekday === day?.toLowerCase() ? 'font-bold' : ''}`}
							aria-current={weekday === day?.toLowerCase() ? 'date' : undefined}
						>
							{dictionary[weekday as keyof typeof dictionary]}
						</span>
						<span>{store.hours[weekday as keyof typeof store.hours]}</span>
					</div>
				))}
			</div>

			{upcomingSpecialHours && upcomingSpecialHours.length > 0 && (
				<div className="flex flex-col mt-4">
					<h3 className="text-sm font-bold">{dictionary['special-hours']}</h3>
					<ul className="text-sm">
						{upcomingSpecialHours.map((specialHours) => (
							<li key={specialHours}>{specialHours}</li>
						))}
					</ul>
				</div>
			)}

			{!isVeryClosed && (
				<div className="flex items-center mt-4">
					<div
						className={`w-3 h-3 rounded-full mr-2 ${isOpen ? 'bg-green-500' : 'bg-red-500'}`}
						role="img"
						aria-label={isOpen ? dictionary['store-open'] : dictionary['store-closed']}
					></div>
					{isOpen ? (
						<span className="text-sm">
							{dictionary['open-today-until']} {end}
						</span>
					) : (
						<span className="text-sm">{dictionary['closed-right-now']}</span>
					)}
				</div>
			)}
		</div>
	)
}
